import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { api_url_v1 } from "../utils/config";

// Helper function to get token dynamically
const getToken = () => {
  if (typeof window !== 'undefined' && window.localStorage) {
    return localStorage.getItem('adminToken');
  }
  return null;
};

// Fetch dashboard data
export const fetchDashboard = createAsyncThunk(
  "dashboard/fetchDashboard",
  async (_, { rejectWithValue }) => {
    try {
      const token = getToken();
      const response = await axios.get(
        `${api_url_v1}/dashboard`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          
            params: {
              _cb: Date.now(), // cache buster
            },
          
        }
      );

      return response.data.data || response.data;
    } catch (error) {
      if (error.response?.data) {
        return rejectWithValue(
          error.response.data.message || "Failed to fetch dashboard data"
        );
      }
      return rejectWithValue(error.message || "Network error");
    }
  }
);

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {
    clearDashboard: (state) => {
      state.data = null;
    },
    clearDashboardError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch dashboard
      .addCase(fetchDashboard.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDashboard.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchDashboard.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearDashboard, clearDashboardError } = dashboardSlice.actions;
export default dashboardSlice.reducer;